var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 4.5V3.75H7.25V4.5H8.75ZM8 8H7.25V8.75H8V8ZM11.5 8.75H12.25V7.25H11.5V8.75ZM13.75 8C13.75 11.1756 11.1756 13.75 8 13.75V15.25C12.0041 15.25 15.25 12.0041 15.25 8H13.75ZM8 13.75C4.82436 13.75 2.25 11.1756 2.25 8H0.75C0.75 12.0041 3.99594 15.25 8 15.25V13.75ZM2.25 8C2.25 4.82436 4.82436 2.25 8 2.25V0.75C3.99594 0.75 0.75 3.99594 0.75 8H2.25ZM8 2.25C11.1756 2.25 13.75 4.82436 13.75 8H15.25C15.25 3.99594 12.0041 0.75 8 0.75V2.25ZM7.25 4.5V8H8.75V4.5H7.25ZM8 8.75H11.5V7.25H8V8.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5976fbc0a0fcb27501c7e80feaac70f9.svg";
export { ForwardRef as ReactComponent };